import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Lock, Loader2, Mail } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

export default function Login() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user && user !== false) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
        } catch (err) {
            setError(apiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-5 py-12">
            <div className="hero-glow absolute inset-0 pointer-events-none" />
            <div className="relative w-full max-w-md bg-white rounded-3xl border border-slate-100 premium-shadow p-8" data-testid="login-card">
                <Link to="/" className="inline-block">
                    <div className="h-10 w-10 rounded-xl bg-slate-900 text-white grid place-items-center font-display font-bold">EG</div>
                </Link>
                <h1 className="mt-5 font-display font-bold text-slate-900 text-2xl tracking-tight">Staff sign in</h1>
                <p className="text-sm text-slate-500 mt-1">Admin access only.</p>

                <form onSubmit={submit} className="mt-7 space-y-4" data-testid="login-form">
                    <label className="block">
                        <span className="block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-1.5">Email</span>
                        <div className="relative">
                            <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                            <input
                                data-testid="login-email"
                                required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                                className="w-full h-11 pl-10 pr-4 rounded-xl bg-white border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-600/30 focus:border-blue-600 transition"
                                placeholder="admin@egwireless.com"
                            />
                        </div>
                    </label>
                    <label className="block">
                        <span className="block text-xs font-semibold text-slate-700 uppercase tracking-wider mb-1.5">Password</span>
                        <div className="relative">
                            <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                            <input
                                data-testid="login-password"
                                required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                                className="w-full h-11 pl-10 pr-4 rounded-xl bg-white border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-600/30 focus:border-blue-600 transition"
                                placeholder="••••••••"
                            />
                        </div>
                    </label>
                    {error && <div data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{error}</div>}
                    <button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 h-11 rounded-xl bg-slate-900 text-white font-semibold hover:bg-slate-800 disabled:opacity-70 transition">
                        {loading && <Loader2 className="w-4 h-4 animate-spin" />} Sign in
                    </button>
                </form>
                <div className="mt-5 text-xs text-slate-400 text-center">
                    Back to <Link to="/" className="underline hover:text-slate-700">main site</Link>
                </div>
            </div>
        </div>
    );
}
